/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from 'react';
import { Pagination, PaginationItem, PaginationLink, Form, FormGroup, Input, InputGroup, InputGroupAddon, Collapse, Badge, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// import services
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

const FormQuestions = props => {

    // variables
    let timeout = 0;

    // states
    const [isLoading, setIsLoading] = useState(true);
    const [isLoading2, setIsLoading2] = useState(false);
    const [isLoading3, setIsLoading3] = useState(false);
    const [formName, setFormName] = useState("");
    const [formQuestions, setFormQuestions] = useState([]);
    const [modal, setModal] = useState({ isVisible: false, isUpdate: false, formName: "", data: { form: "", id: "", type: "", question: "", answers: [], orderNo: "" } });
    const [confirmationModal, setConfirmationModal] = useState({ isVisible: false, id: "" });
    const [pagination, setPagination] = useState({ limit: 10, page: 1 });

    // contexts
    const { theme, colors } = useContext(ThemeContext);

    // use Effects
    useEffect(() => {
        setIsLoading(true);
        setFormName(props.selectedForm.name);
        setModal({ ...modal, data: { ...modal.data, form: props.selectedForm.id } });
        getFormQuestions(props.selectedForm.id);
    }, [pagination.page, pagination.limit, pagination.searchVal]);

    const getFormQuestions = (formId) => {
        AdminService.getFormQuestions(formId, pagination.limit, pagination.page, pagination.searchVal).then(data => {
            try {
                setFormQuestions(data.questions);
                if (data.pagination.totalPages <= data.pagination.page) {
                    data.pagination.page = data.pagination.totalPages;
                }
                setPagination(data.pagination);
                setIsLoading(false);
            } catch (err) {
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                GeneralService.logError('at Admin FormQuestions useEffect', 'Error in try catch block', err.stack);
                setIsLoading(false);
            }
        });
    }

    const toggle = (index) => {
        try {
            const tempArray = [...formQuestions];
            tempArray[index].isOpen = !tempArray[index].isOpen;
            setFormQuestions(tempArray);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin FormQuestions toggle', 'Error in try catch block', err.stack);
        }
    };

    // handle functions
    const handleChange = e => {
        try {
            setModal({ ...modal, data: { ...modal.data, [e.target.name]: e.target.value } });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin FormQuestions handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSearch = e => {
        try {
            let value = e.target.value;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                setPagination({ ...pagination, searchVal: value });
            }, 500);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin FormQuestions handleSerach', 'Error in try catch block', err.stack);
        }
    }

    const handlePagination = (e, index) => {
        e.preventDefault();
        try {
            setPagination({ ...pagination, page: index });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin FormQuestions handlePagination', 'Error in try catch block', err.stack);
        }
    }

    const handleAnsInputKeydown = e => {
        try {
            if (e.keyCode === 13) {
                e.preventDefault();
                handleAddAnswer();
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin FormQuestions handleAnsInputKeydown', 'Error in try catch block', err.stack);
        }
    }

    const goToForms = () => {
        setFormName("");
        setFormQuestions([]);
        setModal({ isVisible: false, isUpdate: false, formName: "", data: { form: "", id: "", type: "", question: "", answers: [], orderNo: "" } });
        setConfirmationModal({ isVisible: false, id: "" });
        setPagination({ limit: 10, page: 1 });
        props.gotoForms();
    }

    const handleAddAnswer = () => {
        try {
            let element = document.getElementById("newAns");
            const value = element.value;
            if (value) {
                setModal({ ...modal, data: { ...modal.data, answers: [...modal.data.answers, value] } });
                element.value = "";
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin FormQuestion handleAddAnswer', 'Error in try catch block', err.stack);
        }
    }

    const handleRemoveAnswer = (ansIndex) => {
        try {
            let tempArray = [...modal.data.answers];
            tempArray.splice(ansIndex, 1);
            setModal({ ...modal, data: { ...modal.data, answers: tempArray } });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin FormQuestion handleRemoveAnswer', 'Error in try catch block', err.stack);
        }
    }

    const handleQuestionSave = e => {
        try {
            setIsLoading3(true);
            e.preventDefault();
            AdminService.addFormQuestion(modal.data).then(data => {
                getFormQuestions(modal.data.form);
                setModal({ isVisible: false, isUpdate: false, data: { ...modal.data, id: "", question: "", answers: [], orderNo: "" } });
                setIsLoading3(false);
            }).catch(error => {
                Alert.error(error.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading3(false);
            });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading3(false);
            GeneralService.logError('at Admin FormQuestion handleQuestionSave', 'Error in try catch block', err.stack);
        }
    }

    const handleQuestionUpdate = e => {
        try {
            setIsLoading3(true);
            e.preventDefault();
            AdminService.updateFormQuestion(modal.data).then(data => {
                getFormQuestions(modal.data.form);
                setModal({ isVisible: false, isUpdate: false, data: { ...modal.data, question: "", answers: [], orderNo: "" } });
                setIsLoading3(false);
            }).catch(error => {
                Alert.error(error.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading3(false);
            });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading3(false);
            GeneralService.logError('at Admin FormQuestion handleQuestionUpdate', 'Error in try catch block', err.stack);
        }
    }

    const handleQuestionDelete = (id) => {
        try {
            setIsLoading2(true);
            AdminService.deleteFormQuestion(id).then(data => {
                getFormQuestions(modal.data.form);
                setConfirmationModal({ isVisible: false, id: "" });
                setModal({ isVisible: false, isUpdate: false, data: { ...modal.data, question: "", answers: [], orderNo: "" } });
                setIsLoading2(false);
            }).catch(error => {
                Alert.error(error.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading2(false);
            });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin FormQuestion handleQuestionDelete', 'Error in try catch block', err.stack);
            setIsLoading2(false)
        }
    }

    return (
        <main>
            <div className="container-fluid">
                <div className="d-flex my-4">
                    <h3 style={{ marginRight: "15px", cursor: "pointer" }} onClick={() => goToForms()}><i className="fas fa-arrow-left"></i></h3>
                    <h3>{formName}</h3>
                    <Button className="ml-auto" style={{ backgroundColor: "#384E73" }} onClick={() => setModal({ ...modal, isVisible: true, data: { ...modal.data, orderNo: formQuestions.length + 1 } })}>Add</Button>
                </div>
                {
                    isLoading ?
                        <h3 className="text-center mt-5">Loading...</h3> :
                        formQuestions.length === 0 ?
                            <h3 className="text-center mt-5">No questions found<br />Add new questions by clicking on Add button</h3> :
                            formQuestions.map((item, index) => (
                                <div key={index} className="p-3 my-3" style={theme.card}>
                                    <div className="row px-3">
                                        <Badge style={{ backgroundColor: colors.primary, marginRight: "15px" }}>{item.orderNo}</Badge>
                                        <span style={theme.headingBold}>{item.question}</span>
                                        <span className="ml-auto">
                                            <span style={{ cursor: "pointer" }} onClick={() => setModal({ isVisible: true, isUpdate: true, data: { ...modal.data, id: item._id, orderNo: item.orderNo, type: item.type, question: item.question, answers: item.answers } })}><i className="fas fa-edit"></i></span>
                                            <span style={{ cursor: "pointer", marginLeft: "15px" }} onClick={() => toggle(index)}>
                                                {
                                                    formQuestions[index].isOpen
                                                        ? <i className="fas fa-angle-up"></i>
                                                        : <i className="fas fa-angle-down"></i>
                                                }
                                            </span>
                                        </span>
                                    </div>

                                    <Collapse isOpen={formQuestions[index].isOpen}>
                                        <hr />
                                        <Table className="mb-0" borderless>
                                            <tbody>
                                                {
                                                    item.answers.map((item, index) => (
                                                        <tr key={index}>
                                                            <td style={{ padding: "0", width: "1px" }}><span>{index + 1}.</span></td>
                                                            <td style={{ padding: "0 0 0 8px" }}><span>{item}</span></td>
                                                        </tr>
                                                        // <div key={index} className="my-auto" style={theme.paragraph}>
                                                        // </div>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                        {/* <Button onClick={() => setAnswerModal({ isVisible: true, answer: "" })}>Add answer</Button> */}
                                    </Collapse>
                                </div>
                            ))
                }
            </div>
            <Modal size="sm" isOpen={confirmationModal.isVisible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setConfirmationModal({ isVisible: false, id: "" })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Are you sure?</span></ModalHeader>
                <ModalBody>
                    <Label>By clicking on Yes button question will be <b>Deleted</b></Label>
                </ModalBody>
                <ModalFooter>
                    <Button type="button" style={theme.formButton} className="btn btn-danger" onClick={() => handleQuestionDelete(confirmationModal.id)} disabled={isLoading2}>
                        {isLoading2 ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Yes
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal size="lg" isOpen={modal.isVisible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setModal({ isVisible: false, isUpdate: false, data: { ...modal.data, id: "", orderNo: 0, question: "", answers: [] } })}><i className="fas fa-times"></i></span>}>
                    <span style={theme.headingBold}>{modal.isUpdate ? "Update question" : "Add question"}</span>
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={modal.isUpdate ? handleQuestionUpdate : handleQuestionSave}>
                        <FormGroup>
                            <Label for="orderNo" style={theme.formBodyText} >Order no</Label>
                            <Input type="number" min={1} max={formQuestions.length + 1} name="orderNo" value={modal.data.orderNo} onChange={handleChange} className="form-control" style={theme.formInput} required />
                        </FormGroup>

                        <FormGroup>
                            <Label for="type" style={theme.formBodyText} >Answer type</Label>
                            <Input type="select" name="type" value={modal.data.type} onChange={handleChange} className="form-control" style={theme.formInput} required >
                                <option value="">Select</option>
                                <option value="radio">Radio (Single answer)</option>
                                <option value="checkbox">Checkbox (Multiple answers)</option>
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label for="question" style={theme.formBodyText} >Question</Label>
                            <Input type="text" name="question" value={modal.data.question} onChange={handleChange} className="form-control" style={theme.formInput} required />
                        </FormGroup>

                        <FormGroup>
                            <Label for="newAns" style={theme.formBodyText} >Answers</Label>
                            {
                                modal.data.answers.map((item, ansIndex) => (
                                    <InputGroup key={ansIndex} className="mb-2">
                                        <Input className="rounded-left" type="text" value={item} disabled />
                                        <InputGroupAddon addonType="append">
                                            <Button className="rounded-right" type="button" style={{ backgroundColor: "#9F1D1D" }} id={ansIndex} onClick={() => handleRemoveAnswer(ansIndex)}>X</Button>
                                        </InputGroupAddon>
                                    </InputGroup>
                                ))
                            }
                            <InputGroup>
                                <Input type="text" id="newAns" name="newAns" style={theme.formInput} onKeyDown={handleAnsInputKeydown}></Input>
                                <InputGroupAddon className="ml-2" addonType="append">
                                    <Button style={{ backgroundColor: "#384E73" }} onClick={() => handleAddAnswer()}>Add</Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </FormGroup>

                        <div className="d-flex">
                            <Button type="submit" style={theme.formButton} disabled={isLoading3}>{isLoading3 ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Submit</Button>
                            <Button type="button" className="ml-auto" style={{ backgroundColor: "#9F1D1D" }} onClick={() => setConfirmationModal({ isVisible: true, id: modal.data.id })}><span><i className="far fa-trash-alt"></i></span></Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </main>
    )

}

export default FormQuestions;